export default "__VITE_ASSET__BXTchS5W__"